// extracted by mini-css-extract-plugin
export default {"richTextWrap":"RichText__richTextWrap___pv1Ei","editor":"RichText__editor___eNtFD"};